/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const locationSearchDataSchema = z.object({
	query: z.string(),
})

export type LocationSearchDataSchema = z.infer<typeof locationSearchDataSchema>
